// extracted by mini-css-extract-plugin
export default {"main":"StoryDetails_main__cq3vo"};